import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { Order } from '@us/web/shared/data-access';
import { OrdersActions, selectLoading, selectOrders } from '@us/web/orders/data-access';
import { OrderListItemComponent } from '../../components/order-list-item/order-list-item.component';
import { RouteUtil } from '@us/web/shared/utils';
import { RouteService } from '@us/web/shops/feature';
import { LetDirective } from '@ngrx/component';
import { BreadcrumbsComponent, EmptyComponent } from '@us/web/shared/ui';

@Component({
    selector: 'us-order-list',
    standalone: true,
    imports: [
        CommonModule,
        IonicModule,
        TranslocoModule,
        OrderListItemComponent,
        LetDirective,
        BreadcrumbsComponent,
        EmptyComponent
    ],
    templateUrl: './order-list.page.html',
    styleUrls: ['./order-list.page.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderListPage implements OnInit {
    private readonly store = inject(Store);
    protected readonly routeService = inject(RouteService);

    readonly homePageUrl$ = this.routeService.homePageUrl$;
    readonly orders$: Observable<Order[]> = this.store.select(selectOrders);
    readonly loading$: Observable<boolean> = this.store.select(selectLoading);

    readonly RouteUtil = RouteUtil;

    ngOnInit(): void {
        this.getData();
    }

    private getData() {
        this.store.dispatch(OrdersActions.loadOrders());
    }
}
